import { UseEndpointOptionsFromProvider, useEndpoint } from '../../core'
import { postAuthLoginTokenExternal } from '../endpoints'

type EndpointParams = Parameters<typeof postAuthLoginTokenExternal>[0]

export const authLoginTokenExternalQueryKey = () => ['authLoginTokenExternal']

export const useAuthLoginTokenExternal = (
  params: EndpointParams,
  options?: UseEndpointOptionsFromProvider<typeof postAuthLoginTokenExternal>,
) =>
  useEndpoint(
    authLoginTokenExternalQueryKey(),
    postAuthLoginTokenExternal(params),
    options,
  )
